
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/leadership/senior-staff/[slug]",
      function () {
        return require("private-next-pages/about/leadership/senior-staff/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/leadership/senior-staff/[slug]"])
      });
    }
  